export default {
  install(Vue, options) {
    Vue.mixin({
      created() {
        Vue.prototype.$currencyCode = document.head.querySelector('meta[name="currency-code"]').content;
      },
    });

    Vue.prototype.$money = function (value, currencyCode = null) {
      if (value === null) {
        return '';
      }

      if (currencyCode === null) {
        currencyCode = this.$currencyCode;
      }

      return new Intl.NumberFormat('en-GB', {style: 'currency', currency: currencyCode, currencyDisplay: 'narrowSymbol'}).format(value / 100);
    };
  },
};
